"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("../styled"));

var _polished = require("polished");

var _InteractionRipples = _interopRequireDefault(require("./InteractionRipples"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  line-height: 30px;\n  overflow: visible;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: ", ";\n  flex-wrap: wrap;\n"])), function (_ref) {
  var labelPosition = _ref.labelPosition;
  return labelPosition === 'left' ? 'row-reverse' : 'initial';
});

var Label = _styled["default"].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  margin: ", ";\n"])), function (_ref2) {
  var labelPosition = _ref2.labelPosition;
  return labelPosition === 'left' ? '2px 5px 0 0' : '2px 0 0 5px';
});

var Input = _styled["default"].input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), _polished.hideVisually);

var Display = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 20px;\n  width: 60px;\n  vertical-align: middle;\n\n  background-color: transparent;\n  position: relative;\n"])));

var GREEN = '#29d99c';

var SwitchSupport = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 10px;\n  width: 60px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n\n  ", ":checked + ", " & {\n    background-color: ", ";\n  }\n"])), function (props) {
  return (0, _polished.transparentize)(0.75, props.theme.foreground);
}, Input, Display, GREEN);

var SwitchCircle = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 10px;\n  border: 1px solid ", ";\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  left: 0;\n  top: -1px;\n  transition: left 150ms ease-in;\n\n  ", ":checked + ", " & {\n    left: 40px;\n    border-color: ", ";\n  }\n"])), function (props) {
  return props.theme.background;
}, function (props) {
  return (0, _polished.transparentize)(0.75, props.theme.foreground);
}, Input, Display, GREEN);

var SwitchInner = _styled["default"].span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 20px;\n  line-height: 20px;\n  position: absolute;\n  left: 20px;\n  top: 0;\n  text-transform: uppercase;\n  text-align: center;\n  font-size: 80%;\n  font-weight: 400;\n\n  ", ":checked + ", " & {\n    left: 0;\n  }\n"])), Input, Display);

var InteractionWrapper = _styled["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 3px;\n  width: 60px;\n  display: inline-block;\n  position: relative;\n  overflow: visible;\n"])));
/**
 * A basic implementation of a switch using a hidden input of type checkbox.
 *
 * Any props not mentiond here are passed through to the underlying `<input>` component.
 */


var Switch = function Switch(_ref3) {
  var label = _ref3.label,
      checked = _ref3.checked,
      onLabel = _ref3.onLabel,
      offLabel = _ref3.offLabel,
      labelPosition = _ref3.labelPosition,
      rest = _objectWithoutProperties(_ref3, ["label", "checked", "onLabel", "offLabel", "labelPosition"]);

  var inlineLabel = label ? /*#__PURE__*/React.createElement(Label, null, label) : null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    labelPosition: labelPosition || 'right'
  }, /*#__PURE__*/React.createElement(InteractionWrapper, null, /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    checked: checked,
    type: "checkbox"
  })), /*#__PURE__*/React.createElement(Display, null, /*#__PURE__*/React.createElement(SwitchSupport, null), /*#__PURE__*/React.createElement(SwitchCircle, null), /*#__PURE__*/React.createElement(SwitchInner, null, /*#__PURE__*/React.createElement(_InteractionRipples["default"], {
    centered: true
  }), checked ? onLabel : offLabel))), inlineLabel);
};

var _default = Switch;
exports["default"] = _default;